import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {PackagingLabel} from '../../../../../../back-office/Models/PackagingLabel';
import {ServiceRequestService} from '../../../../../Services/service-request.service';
import {environment} from '../../../../../../../environments/environment';

@Component({
  selector: 'app-dealer-reply-step-packaging-label',
  templateUrl: './dealer-reply-step-packaging-label.component.html',
  styleUrls: ['./dealer-reply-step-packaging-label.component.scss']
})
export class DealerReplyStepPackagingLabelComponent implements OnInit {

  @Input() Index;
  @Input() isActive;
  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;
  public baseUrl = environment.apiUrl;
  public packagingLabel: PackagingLabel = new PackagingLabel();
  public replyItem;

  constructor(
    private requestService: ServiceRequestService
  ) { }

  ngOnInit() {
    this.requestService.serviceRequest.subscribe(serviceRequest => {
      const replyItems = serviceRequest.reply.replyItems.filter(item => !item.solutionStep.restricted);
      if (replyItems[this.Index]) {
        this.replyItem = replyItems[this.Index];
        this.packagingLabel.replyItem = this.replyItem.id;
        if (this.replyItem.replyPackagingLabel && this.replyItem.replyPackagingLabel.packagingLabel) {
          this.packagingLabel = this.replyItem.replyPackagingLabel.packagingLabel;
        }
      }
    });
  }

  openPdfFile() {
    if (this.packagingLabel && this.packagingLabel.labelFile) {
      const el: HTMLElement = this.downloadLink.nativeElement as HTMLElement;
      el.setAttribute('href', this.baseUrl + '/download?path='
        + this.packagingLabel.labelFile.path + '&filename=' + this.packagingLabel.labelFile.filename);
      el.setAttribute('download', this.baseUrl + '/download?path=' + this.packagingLabel.labelFile.filename);
      el.click();
    }
  }
}
